import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  stepperWrapper: {
    margin: theme.spacing(4.125, 'auto', 15.25, 'auto'),
    maxWidth: '1310px',
    padding: theme.spacing(0, 4.125, 0, 4.125),
  },
}))
